import { render, staticRenderFns } from "./KSkeletonBox.vue?vue&type=template&id=009911d6&scoped=true&"
import script from "./KSkeletonBox.vue?vue&type=script&lang=js&"
export * from "./KSkeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./KSkeletonBox.vue?vue&type=style&index=0&id=009911d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009911d6",
  null
  
)

export default component.exports